import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[sgTableHeaderSkeleton]',
  host: {
    '[class.sg-table-header-skeleton]': 'sgTableHeaderSkeleton',
  },
  standalone: false,
})
export class SgTableHeaderSkeletonDirective implements OnChanges {
  @Input() sgTableHeaderSkeleton = false;

  @Input() skeletonWidth = '100%';

  /**
   * Border radius for the skeleton overlay.
   * To look best, it should match the table header's border radius, minus the border width.
   * @default '7px 7px 0 0'
   */
  @Input() skeletonBorderRadius = '7px 7px 0 0';

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sgTableHeaderSkeleton']) {
      this.updateSkeletonState();
    }

    if (changes['skeletonWidth'] || changes['skeletonBorderRadius']) {
      this.updateSkeletonStyles();
    }
  }

  private updateSkeletonState(): void {
    if (this.sgTableHeaderSkeleton) {
      this.activateSkeleton();
    }
  }

  private activateSkeleton(): void {
    this.measureHeaderHeight();

    // Ensure the element has relative positioning for pseudo-elements
    const position = getComputedStyle(this.el.nativeElement).position;
    if (position === 'static') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    }

    this.updateSkeletonStyles();
  }

  private measureHeaderHeight(): void {
    const headerRow = this.el.nativeElement.querySelector('.mat-header-row');
    const height = headerRow?.getBoundingClientRect().height || 0;
    const finalHeight = height > 0 ? `${height}px` : '34px';
    this.renderer.setStyle(this.el.nativeElement, '--sg-table-header-height', finalHeight);
  }

  private updateSkeletonStyles(): void {
    this.renderer.setStyle(this.el.nativeElement, '--sg-table-skeleton-width', this.skeletonWidth);
    this.renderer.setStyle(this.el.nativeElement, '--sg-table-skeleton-border-radius', this.skeletonBorderRadius);
  }
}
